import { render, staticRenderFns } from "./HoleModal.vue?vue&type=template&id=98f363d0&scoped=true&"
import script from "./HoleModal.vue?vue&type=script&lang=ts&"
export * from "./HoleModal.vue?vue&type=script&lang=ts&"
import style0 from "./HoleModal.vue?vue&type=style&index=0&id=98f363d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f363d0",
  null
  
)

export default component.exports